import React from "react";
import { EbikeLogo } from "../atoms/logos";
import { Div } from "atomize";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <Div m={{ t: "3rem" }}>
      <nav class="navbar navbar-expand-lg navbar-light">
        <Link class="navbar-brand" href="#">
          <EbikeLogo />
        </Link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
          <ul class="navbar-nav  ml-auto mt-2 mt-lg-0">
            <li class="nav-item active">
              <Link class="nav-link" to="#">
                Product <span class="sr-only">(current)</span>
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="#">
                Bike Type
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="#">
                About Us
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="#">
                Testimonials
              </Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" to="#">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </Div>
  );
};

export default Navbar;
